import { loadStripe } from "@stripe/stripe-js/pure";
import Configuration from "config";
import assert from "utils/assert";
import { memoizeAsyncFactory } from "utils/async";

export const getStripeClient = memoizeAsyncFactory(async () => {
  const stripe = await loadStripe(Configuration.STRIPE_API_KEY);
  assert(stripe, "Stripe failed to load");
  return stripe;
});
